import './style.scss'
import React from 'react'
import { FormGroup, FormFeedback, Col, Label } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import Radio from 'components/Radio'

const locales = [
  { code: 'es', label: 'locale_es' },
  { code: 'en', label: 'locale_en' },
  { code: 'fr', label: 'locale_fr' },
  { code: 'de', label: 'locale_de' },
  { code: 'ca', label: 'locale_ca' },
]

/**
 * @param {object} props
 * @param {string} props.name
 * @param {string} props.selected
 * @param {function} props.onChange
 * @param {string} [props.error]
 * @param {boolean} [props.required=false]
 * @param {string} [props.id=locale]
 */
const UserLanguageField = (props) => {
  const { name, id = 'locale', selected, required = false, error, onChange } = props

  return (
    <FormGroup row className='user-locale mt-3'>
      <Col>
        <Label for={id} className={required ? 'required' : ''}>
          {I18n.t('your_language')}
        </Label>
        <div>
          {locales.map((locale) => {
            return (
              <Radio
                key={locale.code}
                value={locale.code}
                name={name || locale.label}
                label={I18n.t(locale.label)}
                onChange={onChange}
                checked={selected === locale.code}
                required={required}
                invalid={!!error}
              />
            )
          })}
        </div>
        <FormFeedback>{error}</FormFeedback>
      </Col>
    </FormGroup>
  )
}

export default UserLanguageField
